import React, { useEffect, useState } from 'react'
import { Flags } from '../../../i18n'
import { CountryCode } from '../../../i18n/countryCodes'
import Image from './Image'

function Flag({
  countryCode,
  width,
  height,
  mt = 0,
  mb = 0,
  ml = 0,
  mr = 0,
  className,
  onClick,
  style,
}: IFlagProps & IMarginProps & IFlagDispatch) {
  const [flagSrc, setFlag] = useState('')
  useEffect(() => {
    Flags.load(countryCode).then(setFlag)
  }, [countryCode])

  return (
    <Image
      className={className}
      src={flagSrc}
      w={width}
      h={height}
      style={Object.assign(
        {},
        {
          marginBottom: mb,
          marginLeft: ml,
          marginRight: mr,
          marginTop: mt,
        },
        style,
      )}
      onClick={onClick}
    />
  )
}

export default Flag

export interface IFlagProps {
  countryCode: CountryCode | any
  width?: number
  height?: number
  className?: string
  style?: React.CSSProperties
}

export interface IFlagDispatch {
  onClick?: () => void
}

export interface IMarginProps {
  mt?: number
  mb?: number
  ml?: number
  mr?: number
}
